/**
 *  @file nxp-modal.service.ts
 *  @since 21-Aug-2017
 */
import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { PershingModalConfig } from '../models/pershing-modal-config.model';

/**
 * @desc     This service should be injected by the components that will launch a modal dialog
 *           with a dynamically loaded component
 * @howToUse The components need to call the openDialog() property with the component that should be
 *            loaded inside the dialog
 */

@Injectable()
export class PershingModalService {
    modalProperties$: Observable<PershingModalProperties>;
    private _modalProperties: any;
    hasConfirmedModal$: Observable<boolean>;
    private _hasConfirmedModal: BehaviorSubject<boolean>;
    // private _modalConfig: any;
    private _dialogRef: MatDialogRef<any>;
    constructor() {
        this._modalProperties = new Subject<PershingModalProperties>();
        this.modalProperties$ = this._modalProperties.asObservable();
        this._hasConfirmedModal = new BehaviorSubject<boolean>(false);
        this.hasConfirmedModal$ = this._hasConfirmedModal.asObservable();
    }

    /**
     * @param component
     */
    openPershingModal(dynamicComponent: ComponentType<any>, modalConfig: PershingModalConfig) {
        this._modalProperties.next({
                    component: dynamicComponent,
                    modalConfig: modalConfig
                });
    }

    closePershingModal(id: String): boolean {
        let isDialogClosed: boolean = false;
        this._dialogRef.close();
        this._dialogRef.afterClosed().subscribe( result => {
            isDialogClosed = (result) ? true : false ;
        });
        return isDialogClosed;
    }

    set dialogRef(dialogRef: MatDialogRef<any>) {
        this._dialogRef = dialogRef;
    }

    setConfirmationModal(value: boolean): void {
        this._hasConfirmedModal.next(value);
    }
}

export class PershingModalProperties {
    /** component to be opened inside the dialog */
    component: ComponentType<any>;
    modalConfig: PershingModalConfig;
}
